module.exports = __webpack_public_path__ + "static/img/icon-03.b9872cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/how-to-books/icon-03.png
// module id = yVxx
// module chunks = 1